import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { onBasePath } from '../../paths/onBasePath';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Dashboard.translations.json';
import { SectionContextProvider } from '../../common/SectionContext';
import { NotFound } from '../NotFound';
import { DashboardContent } from './DashboardContent';
import { DashboardSettings } from './DashboardSettings';
import { path } from '../../paths';

const { addTranslations, Translation } = i18nNsFactory('dashboard');
addTranslations(translations);

export const DASHBOARD_ROUTES = [
  {
    path: path.dashboard,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.dashboard')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <DashboardContent />,
      },
      {
        path: path.dashboardSettings,
        element: <DashboardSettings />,
        renderBreadcrumb: () => (
          <Translation>{(t) => t('breadcrumb.dashboardSettings')}</Translation>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export interface DashboardProps {
  basePath: string;
}

export const Dashboard: FC<DashboardProps> = ({ basePath }) => (
  <SectionContextProvider basePath={basePath}>
    {useRoutes(onBasePath(basePath, DASHBOARD_ROUTES))}
  </SectionContextProvider>
);
